import Http from '../http'

export default {

  index() {
    return Http.get(`/companies`)
  },


  create(company){
    return Http.post(`/companies`, {company: {
      ...company,
    }})
  },
  createFormData(company){
    return Http.post(`/companies`, company)
  },

  updateFormData(company){
    return Http.put(`/companies/${company.get("company[id]")}`, company);
  },
  updateLogo(id, company){
    return Http.put(`/companies/${id}`, company);
  },
  update(company){
    return Http.put(`/companies/${company.id}`, {
      company: {
        ...company,
      },
    });
  },

  show(id) {
    return Http.get(`/companies/${id}`);
  },

  delete(id){
    return Http.delete(`/companies/${id}`)
  }

}